import {Box, Tag2Icon, Typography} from '@customink/pigment-react';
import React from 'react';

const EmptyStateCardsView = () => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'white',
        border: `1px solid rgba(0, 0, 0, 0.11)`,
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '150px 0',
        width: '100%'
      }}>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: '#F2F2F2',
          borderRadius: '50%',
          display: 'flex',
          flexDirection: 'column',
          height: '72px',
          justifyContent: 'center',
          marginBottom: '16px',
          width: '72px'
        }}>
        <Tag2Icon fontSize="large" color="disabled" />
      </Box>
      <Typography variant="buttonLg" color="gray">
        No results found
      </Typography>
    </Box>
  );
};

export default EmptyStateCardsView;
